// @/utils/gtmConsent.js
import { 
    hasConsent, 
    subscribeToConsentChanges,
    hasUserMadeChoice 
  } from './cookieConsentUtil';
  
  /**
   * Инициализирует Google Consent Mode
   */
  export const initializeGTMConsent = () => {
    if (typeof window === 'undefined') return;
  
    // Устанавливаем начальные настройки согласия
    // По умолчанию все отклонены, кроме функциональных и безопасности
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
  
    gtag('consent', 'default', {
      'analytics_storage': 'denied',
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'functionality_storage': 'granted',
      'personalization_storage': 'denied',
      'security_storage': 'granted',
      'wait_for_update': 800
    });
  
    // Проверяем существующие настройки согласия пользователя
    if (hasUserMadeChoice()) {
      const preferences = {
        analytics: hasConsent('analytics'),
        advertising: hasConsent('advertising')
      };
      
      updateConsentState(preferences.analytics, preferences.advertising);
    }
  
    // Подписываемся на изменения согласий
    subscribeToConsentChanges((newPreferences) => {
      updateConsentState(newPreferences.analytics, newPreferences.advertising);
    });
  };
  
  /**
   * Обновляет состояние согласия в GTM
   * @param {boolean} analytics - Разрешена ли аналитика
   * @param {boolean} advertising - Разрешена ли реклама
   */
  export const updateConsentState = (analytics, advertising) => {
    if (typeof window === 'undefined') return;
  
    // Обновляем настройки согласия в GTM
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
  
    gtag('consent', 'update', {
      'analytics_storage': analytics ? 'granted' : 'denied',
      'ad_storage': advertising ? 'granted' : 'denied',
      'ad_user_data': advertising ? 'granted' : 'denied',
      'ad_personalization': advertising ? 'granted' : 'denied',
      'personalization_storage': advertising ? 'granted' : 'denied'
    });
  
    // Отправляем событие в Data Layer
    window.dataLayer.push({
      'event': analytics && advertising ? 'consent_given' : 
               (!analytics && !advertising ? 'consent_rejected' : 'consent_updated'),
      'consentStatus': analytics && advertising ? 'granted' : 
                       (!analytics && !advertising ? 'denied' : 'partial'),
      'analyticsConsent': analytics ? 'granted' : 'denied',
      'adsConsent': advertising ? 'granted' : 'denied'
    });
  };